import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/styles/overrides.scss";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#293578",
        secondary: "#ee4137",
        anchor: "#017148",
      },
    },
  },
});
